import {
  dmSans400NormalWoff2DataUrl,
  dmSans700NormalWoff2DataUrl,
} from "./memberCredentialEmailPreviewFonts";

const memberCredentialPreviewStyle = `<style data-member-credential-preview="true">
@font-face {
  font-family: "CMP Credential Preview DM Sans";
  font-style: normal;
  font-weight: 400;
  font-display: block;
  src: url("${dmSans400NormalWoff2DataUrl}") format("woff2");
}
@font-face {
  font-family: "CMP Credential Preview DM Sans";
  font-style: normal;
  font-weight: 700;
  font-display: block;
  src: url("${dmSans700NormalWoff2DataUrl}") format("woff2");
}
html, body {
  color: #0A0A0A;
  font-family: "CMP Credential Preview DM Sans", sans-serif;
  font-size: 14px;
  line-height: 1.6;
}
body {
  margin: 0;
}
[data-cmp-primary-credentials="true"] {
  font-family: "CMP Credential Preview DM Sans", sans-serif !important;
}
</style>`;

export const buildMemberCredentialEmailPreviewDocument = (html: string) => {
  const closingHead = /<\/head\s*>/i;
  if (closingHead.test(html)) {
    return html.replace(closingHead, `${memberCredentialPreviewStyle}$&`);
  }

  const openingBody = /<body(?:\s[^>]*)?>/i;
  if (openingBody.test(html)) {
    return html.replace(openingBody, `${memberCredentialPreviewStyle}$&`);
  }

  return `<!DOCTYPE html><html lang="en"><head><meta charset="UTF-8">${memberCredentialPreviewStyle}</head><body>${html}</body></html>`;
};
